import { css, cx } from '@/styled-system/css';

import { Combobox } from '../combobox';
import type { ComboboxValueType } from '../combobox';
import type { ComboboxTriggerRenderPropsInterface } from '../combobox';
import { dropdownSelectChipStyles } from './styles/dropdown-select.styles';
import type { DropdownSelectPropsInterface } from './types/dropdown-select.types';

/**
 * If you are not customizing options with `appearance`, `icons`, or `meta` from
 * Combobox, or using a multiselectable dropdown,
 * then it is better to use the Select component because
 * mobile browsers will optimize the user interaction.
 *
 * @extends Combobox
 * @since 8.28.0
 */
export const DropdownSelect = <ValueType extends ComboboxValueType>(
  props: DropdownSelectPropsInterface<ValueType>,
) => {
  const renderChip: ComboboxTriggerRenderPropsInterface['renderChip'] = (renderProps) => {
    const { children, onClick: _onClick, key, isLast, ...renderPropsRest } = renderProps;
    return (
      <span key={key} className={cx('c11n', css(dropdownSelectChipStyles))} {...renderPropsRest}>
        {children}
        {!isLast ? ',' : null}
      </span>
    );
  };
  return (
    <Combobox {...props} autoCompleteBehavior="none" editable={false} renderChip={renderChip} />
  );
};

DropdownSelect.displayName = 'DropdownSelect';
